import React, { useEffect, useState } from 'react';
import {
  Modal,
  Box,
  TextField,
  Autocomplete,
  Button,
  Typography,
  Snackbar,
  Alert,
} from '@mui/material';
import { Country, State } from 'country-state-city';
import API from '../../api/api';

const EditStateModal = ({ open, handleClose, postService, cb = () => {} }) => {
  const [loading, setLoading] = useState(false);
  const [PremiumService, setPremiumService] = useState('');
  const [service, setService] = useState('');
  const [country, setCountry] = useState(null);
  const [countryCode, setCountryCode] = useState('');
  const [states, setStates] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [manualCountryChange, setManualCountryChange] = useState(false);
  const [lossCode, setLossCode] = useState('');
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: '' });

  // Load countries
  const countryList = Country.getAllCountries().map((country) => ({
    name: country.name,
    code: country.isoCode,
  }));


useEffect(() => {
  if (postService) {
    setService(postService.service || '');
    setPremiumService(postService.premium_service || '');

    setLossCode(postService.loss_code || '');

    const matchedCountry = countryList.find(c => c.name === postService.country);
    setCountry(matchedCountry || null);
    setCountryCode(postService.country_code || '');

    if (matchedCountry) {
      const stateData = State.getStatesOfCountry(matchedCountry.code).map((state) => ({
        name: state.name,
        code: state.isoCode,
      }));
      setStateOptions(stateData);

      // Select matching states from stateData
      // const selectedStates = postService.states.map((s) =>
      //   stateData.find((opt) => opt.name === s.name)
      // ).filter(Boolean); // remove unmatched

      // setStates(selectedStates);
    }
  }
}, [postService]);


useEffect(() => {
  if (postService && stateOptions.length > 0 && !manualCountryChange) {
   const selectedStates = postService.states.map((s) => {
  const match = stateOptions.find((opt) => opt.name === s.name);
  return match
    ? {
        ...match,
        _id: s._id, // bring in the original _id
        is_premium: s.is_premium, // bring in original is_premium
      }
    : s; // fallback to original state object
});
setStates(selectedStates);
  }
}, [postService, stateOptions, manualCountryChange]);

  // Update states list when country changes
  useEffect(() => {
    if (country) {
      setCountryCode(country.code);
      const stateData = State.getStatesOfCountry(country.code).map((state) => ({
        name: state.name,
        code: state.isoCode,
      }));
      setStateOptions(stateData);
      setStates([]); 

    } else {
      setCountryCode('');
      setStateOptions([]);
      setStates([]);
    }
  }, [country]);



  useEffect(() => {
  if (postService) {
    setManualCountryChange(false); 
  }
}, [postService]);

useEffect(()=>{
console.log("stateOptions================>", stateOptions)
},[stateOptions])


  const validateForm = () => {
    const newErrors = {};
    if (!service.trim()) newErrors.service = 'Service is required.';
    if (!country || !country.name) newErrors.country = 'Country is required.';
    if (!countryCode.trim()) newErrors.countryCode = 'Country Code is required.';
    if (!lossCode.trim()) newErrors.lossCode = 'Loss Code is required.';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      setSnackbar({ open: true, message: 'Please fix the errors in the form.', severity: 'error' });
      return;
    }
    console.log(JSON.stringify(states, null, 5))
    const payload = {
      id: postService._id,
      service,
      premium_service:PremiumService||'',
      country: country?.name || '',
      country_code: countryCode,
      loss_code: lossCode,
      state: states
    };

    try {
      setLoading(true);
      await API.post('/suadmin/edit-post-service', payload);
      setSnackbar({ open: true, message: 'Post Service updated successfully!', severity: 'success' });
      cb();
      handleClose();
    } catch (error) {
      let errorMessage = 'An error occurred while updating the post service.';
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      setSnackbar({ open: true, message: errorMessage, severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar({ open: false, message: '', severity: '' });
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            maxWidth: 500,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" mb={2}>
            Edit Post Service
          </Typography>

          <TextField
            label="Standard Service"
            fullWidth
            value={service}
            onChange={(e) => setService(e.target.value)}
            margin="normal"
            error={!!errors.service}
            helperText={errors.service}
          />
             <TextField
            label="Premium Serivce"
            fullWidth
            value={PremiumService}
            onChange={(e) => setPremiumService(e.target.value)}
            margin="normal"
            // error={!!errors.service}
            // helperText={errors.service}
          />

          <Autocomplete
            options={countryList}
            getOptionLabel={(option) => option.name}
            value={country}
            onChange={(event, newValue) => {
              setCountry(newValue)
            setManualCountryChange(true)
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Country"
                margin="normal"
                error={!!errors.country}
                helperText={errors.country}
              />
            )}
          />

          <TextField
            label="Country Code"
            fullWidth
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value.toUpperCase())}
            margin="normal"
            error={!!errors.countryCode}
            helperText={errors.countryCode}
            disabled={true}
          />

          {/* <Autocomplete
            multiple
            options={stateOptions}
            getOptionLabel={(option) => option.name}
            value={states}
            onChange={(event, newValue) => setStates(newValue)}
            disabled={!country}
            renderInput={(params) => (
              <TextField {...params} label="States" margin="normal" />
            )}
          /> */}

          <Box sx={{
            overflow:"auto",
            "& .MuiFormControl-root":{
              height:"100%",
            },
          }}>
  <Autocomplete
  multiple
  options={stateOptions}
  getOptionLabel={(option) => option.name}
  isOptionEqualToValue={(option, value) => option.name === value.name}
  value={states}
  onChange={(event, newValue) => {
    setStates(newValue);
  }}
  renderInput={(params) => <TextField {...params} label="States" />}
  fullWidth
/>

          </Box>




          <TextField
            label="Loss Code"
            fullWidth
            value={lossCode}
            onChange={(e) => setLossCode(e.target.value)}
            margin="normal"
            error={!!errors.lossCode}
            helperText={errors.lossCode}
          />

          <Box mt={3} display="flex" justifyContent="flex-end">
            <Button onClick={handleClose} sx={{ mr: 2 }}>
              Cancel
            </Button>
            <Button
              disabled={loading}
              variant="contained"
              onClick={handleSubmit}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default EditStateModal;
